import { CATEGORIES } from '@kijiji/category'
import { type PersonalAccount } from '@kijiji/generated/graphql-types'
import { type TFunction } from 'i18next'
import { type NextRouter } from 'next/router'
import qs from 'query-string'

import { ICO_UTM_PARAMS } from '@/constants/ico'
import { getSrpComposedUrl } from '@/domain/srp/getSrpComposedUrl'
import { changeCategoryOfUrl } from '@/features/search/utils/vertical-brp/changeCategoryOfUrl'
import { type RouteLocale } from '@/hooks/useLocale'
import { openBillOfSale } from '@/utils/autoCanadaHelper'

const MAINTAIN_AND_PROTECT = [
  {
    name: 'parts_tires_accessories',
    categoryId: CATEGORIES.AUTO_PARTS_TIRES_CATEGORY_ID,
    seoParam: 'b-auto-parts-tires',
  },
  {
    name: 'automotive_services',
    categoryId: CATEGORIES.AUTOMOTIVE_SERVICES_CATEGORY_ID,
    seoParam: 'b-automotive-services',
  },
  {
    name: 'warranty',
  },
  {
    name: 'bill_of_sale',
  },
]

export const getMaintainAndProtectData = (
  t: TFunction,
  routerQuery: NextRouter['query'],
  routeLocale: RouteLocale,
  autocanData: { warrantyUrl: string },
  profileData: PersonalAccount | undefined
) => {
  const currUrl = getSrpComposedUrl(routerQuery)
  const { query } = qs.parseUrl(currUrl.href)

  const utmParams = {
    utmSource: ICO_UTM_PARAMS.UTM_SOURCE,
    utmCampaign: ICO_UTM_PARAMS.UTM_CAMPAIGN_BRP,
    utmContent: ICO_UTM_PARAMS.UTM_CONTENT_CONTENT_CARD_CTA,
  }

  return MAINTAIN_AND_PROTECT.map(({ name, categoryId, seoParam }) => {
    const i18nLabelKey = `srp:maintain_protect.${name}`
    const imgSrc = `/next-assets/images/autos-maintain-protect/${name}.jpg`
    let seoUrl = currUrl.href
    let externalUrl = ''

    if (categoryId) {
      seoUrl = changeCategoryOfUrl(seoUrl, name, categoryId, t, seoParam)
    }

    if (name === 'bill_of_sale') {
      const shouldOpenBillOfSalePopup = false

      externalUrl = openBillOfSale(
        routeLocale,
        profileData?.id,
        '',
        utmParams,
        shouldOpenBillOfSalePopup
      )
    }

    if (name === 'warranty' && autocanData) {
      externalUrl = `${autocanData?.warrantyUrl}?utm_source=${utmParams.utmSource}&utm_campaign=${utmParams.utmCampaign}&utm_content=${utmParams.utmContent}`
    }

    return {
      label: t(i18nLabelKey),
      imgSrc: imgSrc,
      url: externalUrl ? externalUrl : qs.stringifyUrl({ url: seoUrl, query }),
      isExternalUrl: !!externalUrl,
    }
  })
}
